
export const getters = {
  systemPermissions: state => state.permissions
}

export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/permissions/getters.js